import React, { useEffect, useState } from "react";
import { View, StyleSheet, Image, Platform, Dimensions, ScrollView, TouchableOpacity } from "react-native";
import LottieView from "lottie-react-native";
import Header from "../../header/Header";
import Typography from "../../typography/Typography";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TextAlignTokens } from "@voltmoney/schema";
import { ACUTE_ICON, DIGIO_IMAGE, LOTTIE_URL, SHIELD_ICON, WORKLOAD_ICON } from "./constant";
import { ModalAlignmentEnum } from "@voltmoney/types";
import BottomSheet from "../BottomSheet";
import { isMobile } from "../../stack/utils";
import { getScreenType } from "../utils";
import CoBorrowerDigioList from "./CoBorrowerDigioList";
import Icon from "../../icon/Icon";
import Button from "../../button/Button";
import CoBorrowerDigioFooter from "./CoBorrowerDigioFooter";
const CoBorrowerKycVerificationPage = ({ type, stepperProps, headerTitle, backAction, triggerAction, lenderInfo, lenderIcon, aadharInitAction, height, successModal, successTitle, successSubTitle, successButtonTitle, failedModal, failedTitle, failedSubTitle, failedButtonTitle, failureAction, continueAction, loading, shouldShowDocUploadOption, documentUploadAction, fullName, doKycLaterAction, counter }) => {
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showFailedModal, setShowFailedModal] = useState(false);
    const [successLottie, setSuccessLottie] = useState("");
    const [isDismissable, setDismissable] = useState(false);
    const [hasNavigated, setHasNavigated] = useState(false);
    useEffect(() => {
        setHasNavigated(false);
    }, []);
    useEffect(() => {
        if (successModal) {
            setTimeout(() => {
                continueAction && !hasNavigated && triggerAction(continueAction);
            }, 3000);
        }
        setShowSuccessModal(successModal);
        setShowFailedModal(failedModal);
    }, [failedModal, successModal, counter]);
    useEffect(() => {
        fetch(LOTTIE_URL, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            setSuccessLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
    }, [successModal, failedModal]);
    const modalContentPresenter = () => {
        return (React.createElement(View, { style: styles.modalContainer },
            successLottie &&
                React.createElement(LottieView, { source: successLottie, style: { width: 70, height: 70 }, autoPlay: true, loop: true }),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { label: successTitle, fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: "You will be redirected to next step in few seconds", fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 32 })),
            React.createElement(View, { nativeID: "bt_borrowerKyc_success", style: { position: 'absolute', bottom: 0, width: '80%', paddingHorizontal: 16, marginBottom: 10 } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: successButtonTitle, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        continueAction && triggerAction(continueAction);
                        setShowSuccessModal(false);
                        setHasNavigated(true);
                    } }))));
    };
    const renderUserCancelledContent = () => {
        return (React.createElement(View, { style: styles.userCancelledCard },
            React.createElement(Icon, { name: IconTokens.ErrorIcon, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: styles.title },
                React.createElement(Typography, { label: failedTitle, fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.subTitle },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: failedSubTitle, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { nativeID: "bt_coBorrowerKyc_error", style: styles.errorButton },
                React.createElement(View, null,
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: failedButtonTitle, width: ButtonWidthTypeToken.FULL, onPress: () => {
                            failureAction && triggerAction(failureAction);
                            setShowFailedModal(false);
                        } })))));
    };
    const DynamicTitle = lenderInfo?.lenderAccountId === "Tata" ? "Instantly pull Aadhaar" : "Instantly pull Aadhaar & PAN";
    const handleCard = () => {
        if (showFailedModal)
            setShowFailedModal(false);
        else
            setShowSuccessModal(true);
    };
    return (React.createElement(View, { style: [styles.container, { height: Platform.OS === "ios" ? height - 14 : height }] },
        React.createElement(View, { style: styles.header },
            React.createElement(Header, { id: "bt_coBorrowerKyc_goBack", type: type, stepperProps: stepperProps, isBackButton: true, title: headerTitle, onPress: () => {
                    if (backAction) {
                        triggerAction(backAction);
                    }
                } })),
        React.createElement(View, { style: {
                padding: 8,
                backgroundColor: '#FEF4E6',
                flexDirection: 'row',
                alignContent: 'center',
                borderRadius: 4,
                marginBottom: 16,
                marginTop: 24,
                marginHorizontal: 16
            } },
            React.createElement(Typography, { label: "Joint holder: ", fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 16 }),
            React.createElement(Typography, { label: `${fullName}`, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: '700', lineHeight: 16 })),
        React.createElement(View, { style: styles.kycText },
            React.createElement(Typography, { label: "Instant KYC via DigiLocker", fontWeight: '600', lineHeight: 24, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.LG, fontFamily: FontFamilyTokens.Poppins }),
            shouldShowDocUploadOption &&
                React.createElement(View, null,
                    React.createElement(Typography, { label: "Aadhaar not linked with mobile?", fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(TouchableOpacity, { onPress: () => {
                            documentUploadAction &&
                                triggerAction(documentUploadAction);
                        } },
                        React.createElement(Typography, { label: "Upload KYC documents", fontWeight: '600', lineHeight: 18, color: ColorTokens.Primary_100, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Poppins })))),
        React.createElement(View, null,
            React.createElement(ScrollView, { style: { paddingBottom: 80, height: height - 380 } },
                React.createElement(View, { style: styles.digiLockerContainer },
                    React.createElement(View, { style: styles.image },
                        React.createElement(Image, { resizeMode: 'contain', source: { uri: DIGIO_IMAGE }, style: styles.digioImage })),
                    React.createElement(View, { style: styles.benefitContainer },
                        React.createElement(View, null,
                            React.createElement(Typography, { label: "Digilocker benefits", fontWeight: '500', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter })),
                        React.createElement(View, null,
                            React.createElement(CoBorrowerDigioList, { title: "Fast & secure way to share documents", imageUrl: SHIELD_ICON }),
                            React.createElement(CoBorrowerDigioList, { title: DynamicTitle, imageUrl: ACUTE_ICON }),
                            React.createElement(CoBorrowerDigioList, { title: "Developed by Government of India", imageUrl: WORKLOAD_ICON })))))),
        React.createElement(CoBorrowerDigioFooter, { triggerAction: triggerAction, aadharInitAction: aadharInitAction, lenderInfo: lenderInfo, lenderIcon: lenderIcon, loading: loading, doKycLaterAction: doKycLaterAction }),
        (showSuccessModal || showFailedModal) && React.createElement(View, { style: styles.modal },
            React.createElement(BottomSheet, { id: "bt_coBorrowerKyc_cancel", autoAdjustHeight: false, height: showFailedModal ? 280 : 228, width: '100%', closeFunction: handleCard, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: isDismissable, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: true }, showSuccessModal ? modalContentPresenter() : renderUserCancelledContent()))));
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: -16,
    },
    kycText: {
        marginHorizontal: 16,
    },
    header: {
        ...Platform.OS === "ios" && {
            marginTop: 32
        }
    },
    digiLockerContainer: {
        marginHorizontal: 16,
        marginTop: 24,
        borderRadius: 8,
        borderColor: '#1434CB',
        borderWidth: 1,
        backgroundColor: ColorTokens.Primary_02,
    },
    image: {
        paddingLeft: 16,
        paddingTop: 16,
    },
    digioImage: {
        height: 40,
        width: 120,
    },
    benefitContainer: {
        padding: 16,
    },
    modal: {
        bottom: 0,
        position: 'absolute',
        zIndex: 1,
    },
    userCancelledCard: {
        alignItems: "center",
        padding: 16,
        zIndex: 2,
        flex: 1
    },
    title: {
        marginTop: 16,
    },
    subTitle: {
        marginTop: 16,
        padding: 8,
        marginBottom: 8,
    },
    errorButton: {
        width: '90%',
        marginTop: 16,
        paddingHorizontal: 16,
        paddingBottom: 8,
        marginBottom: 4
    },
    modalContainer: {
        alignItems: "center",
        padding: 16,
        flex: 1
    },
});
export default CoBorrowerKycVerificationPage;
